import api from "./api";

type Session = {
  email: string;
  password: string;
}

const create = (data: Session) => {
	return api.get("login", { headers: { jwtusername: data.email, jwtpassword: data.password } });
};

const getRoles = () => {
  return api.get("/api_front/UserLoginSearch");
};

interface UpdatePassword {
  old_password: string,
  password: string
}
const updatePassword = (values: UpdatePassword) => {
  return api.patch("/passwords/change", values);
}

const forgetPassword = (email: string) => {
  return api.post("/passwords/forgot", { email });
}

interface ResetPasswordProps {
  token: string;
  password: string;
  password_confirmation: string;
}
const resetPassword = (values: ResetPasswordProps) => {
  return api.post("/passwords/reset", values);
}

interface changePasswordProps {
  PSW: string;
}
const changePassword = (psw: changePasswordProps) => {
  return api.patch("/api_front/clientUpdatePSW", psw);
}

const isUpdated = () => {
  return api.get("/api_front/IsUpdatePSW");
}

const resetFlag = () => {
  return api.patch("/api_front/ResetPSW");
}

export {
  create,
  getRoles,
  updatePassword,
  forgetPassword,
  resetPassword,
  changePassword,
  isUpdated,
  resetFlag
};